import {http, onSuccess, onFail} from "./http";

const timeout = 10*60*1000;

export const eventStatisticViewTimeClientsGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/viewTime/client`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticTimeLineGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/timeLine`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticOnlineGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/online`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticViewTimeGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/viewTime`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticStreamsGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/streams`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticBrowsersGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/browsers`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticDevicesGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/devices`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticCountriesGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/countries`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticCitiesGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/cities`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticClientsGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/clients`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticHostsGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/hosts`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticPollsGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/polls`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticActivityTopGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/activityTop`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticNotificationsGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/notifications`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticBannersGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/banners`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticMessagesGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/messages`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticPaymentsGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/payments`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticRegistrationConversion = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/conversion`, {params, timeout})
        .then(onSuccess, onFail);
export const eventStatisticRegistrationWatchConversion = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/streamConversion`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticEventWatchReport = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/streamWatch`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticStreamWatchReport = (eventPassword, streamId, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/streamWatch/${streamId}`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticStreamWatchEpisodesGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/episodes`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticPollsMember = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/pollsMember`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticEventReactions = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/reaction`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticStreamReactions = (eventPassword, streamId, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/stream/${streamId}/reaction`, {params, timeout})
        .then(onSuccess, onFail);

export const eventStatisticQuizzesGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/statistic/quizzes`, {params, timeout})
        .then(onSuccess, onFail);
